const MuiInputAdornment = {
  styleOverrides: {
    positionEnd: {
      marginLeft: 0,
      marginRight: '12px',
    },
  },
};

export default MuiInputAdornment;
